import Vue from "vue";
import VueRouter from "vue-router";
import mainLayout from "../layout/main.vue";
import index from "../views/index.vue";
import store from "@/store/index";
import api from "@/assets/js/api";
import { isNotEmpty, isOpenPermissionDialog } from "@/assets/js/utils";
import shopCenterConst from "@/assets/js/shopCenterConst";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: mainLayout,
    children: [
      {
        path: "/",
        name: "main-layout-index",
        component: index,
        redirect: "/shop/info",
        meta: {
          needLogin: true,
        },
      },
      {
        path: "/user/logout",
        name: "logout",
        component: index,
        meta: {
          needLogin: true,
        },
      },
      {
        path: "/shop/info",
        name: "shop-overview",
        component: () => import("../views/shop/info"),
        meta: {
          needLogin: true,
          title: "店铺总览",
        },
      },
      {
        path: "/info/shop/info",
        name: "shop-info",
        component: () => import("../views/info/shop-info"),
        meta: {
          needLogin: true,
          title: "店铺信息",
        },
      },
      // {
      //   path: "/info/shop/template",
      //   name: "shop-template",
      //   component: () => import("../views/info/shop-template"),
      //   meta: {
      //     needLogin: true,
      //     title: "模板设置",
      //   },
      // },
      // {
      //   path: "/info/shop/premote",
      //   name: "shop-premote",
      //   component: () => import("../views/info/premote"),
      //   meta: {
      //     needLogin: true,
      //     title: "推广设置",
      //   },
      // },
      {
        path: "/info/user/info",
        name: "user-info",
        component: () => import("../views/info/user-info"),
        meta: {
          needLogin: true,
          title: "个人信息",
        },
      },
      {
        path: "/trade/fund",
        name: "trade-fund",
        component: () => import("../views/trade/fund"),
        meta: {
          needLogin: true,
          title: "资产管理",
        },
      },
      {
        path: "/resource/album/list",
        name: "resource-album-list",
        component: () => import("../views/resource/album/index.vue"),
        meta: {
          needLogin: true,
          title: "专辑管理",
        },
      },
      {
        path: "/resource/album/upload",
        name: "resource-album-upload",
        component: () => import("../views/resource/album/album-upload.vue"),
        meta: {
          needLogin: true,
          title: "专辑上传",
        },
      },
      {
        path: "/resource/video/upload",
        name: "resource-video-upload",
        component: () => import("../views/resource/video/video-upload.vue"),
        meta: {
          needLogin: true,
          title: "视频上传",
        },
      },
      {
        path: "/resource/document/upload",
        name: "resource-document-upload",
        component: () =>
          import("../views/resource/document/resource-upload.vue"),
        meta: {
          needLogin: true,
          title: "资料上传",
        },
      },
      {
        path: "/resource/data",
        name: "resource-data",
        component: () => import("../views/dataAnalysis/content-data"),
        meta: {
          needLogin: true,
          title: "内容数据",
        },
      },
      {
        path: "/resource/traffic-data",
        name: "traffic-data",
        component: () => import("../views/dataAnalysis/traffic-data"),
        meta: {
          needLogin: true,
          title: "流量数据",
        },
      },
      {
        path: "/resource/trade-data",
        name: "trade-data",
        component: () => import("../views/dataAnalysis/trade-data"),
        meta: {
          needLogin: true,
          title: "交易数据",
        },
      },
      {
        path: "/resource/user-data",
        name: "user-data",
        component: () => import("../views/dataAnalysis/user-data"),
        meta: {
          needLogin: true,
          title: "用户数据",
        },
      },
      {
        path: "/resource/video/list",
        name: "resource-video-list",
        component: () => import("../views/resource/video/list.vue"),
        meta: {
          needLogin: true,
          title: "视频管理",
        },
      },
      {
        path: "/resource/document/list",
        name: "resource-document-list",
        component: () => import("../views/resource/document/list.vue"),
        meta: {
          needLogin: true,
          title: "资料管理",
        },
      },
      {
        path: "/resource/article/list",
        name: "resource-article-list",
        component: () => import("../views/resource/article/articlelist.vue"),
        meta: {
          needLogin: true,
          title: "文章管理",
        },
      },
      {
        path: "/info/shop/shop-decoration-index",
        name: "shop-decoration-index",
        component: () => import("../views/info/shop-decoration-index"),
        meta: {
          needLogin: true,
          title: "店铺装修",
        },
      },
      {
        path: "/info/shop/employee-list",
        name: "employee-list",
        component: () => import("../views/info/employee-list"),
        meta: {
          needLogin: true,
          title: "店员信息",
        },
      },
      // {
      //   path: "/info/shop/tab-decoration",
      //   name: "tab-decoration",
      //   component: () => import("../views/info/tab-decoration"),
      //   meta: {
      //     needLogin: true,
      //     title: "导航装修",
      //   },
      // },
      {
        path: "/info/shop/index-decoration",
        name: "index-decoration",
        component: () => import("../views/info/index-decoration"),
        meta: {
          needLogin: true,
          title: "首页装修",
        },
      },
      {
        path: "/info/shop/m-index-decoration",
        name: "m-index-decoration",
        component: () => import("../views/info/m-index-decoration"),
        meta: {
          needLogin: true,
          title: "移动端装修",
        },
      },
      {
        path: "/resource/article/upload",
        name: "resource-article-upload",
        component: () => import("../views/resource/article/article-upload.vue"),
        meta: {
          needLogin: true,
          title: "文章上传",
        },
      },
      {
        path: "/authentication/shop-authentication",
        name: "shop-authentication",
        component: () => import("../views/authentication/shop-authentication"),
        meta: {
          needLogin: true,
          title: "店铺认证",
        },
      },
      {
        path: "/authentication/enterprise-apply",
        name: "enterptise-apply",
        component: () => import("../views/authentication/enterprise-apply"),
        meta: {
          needLogin: true,
          title: "店铺认证",
        },
      },
      {
        path: "/marketing/discount",
        name: "marketing-discount",
        component: () => import("../views/marketing/discount/activity.vue"),
        meta: {
          needLogin: true,
          title: "限时折扣",
        },
      },
      {
        path: "/marketing/addActivity",
        name: "marketing-discount-add-activity",
        component: () => import("../views/marketing/discount/addActivity.vue"),
        meta: {
          needLogin: true,
          title: "新建活动",
        },
      },
      {
        path: "/tutorial/index",
        name: "tutorial-index",
        component: () => import("../views/create-college/college-index.vue"),
        meta: {
          needLogin: true,
          title: "创作学院",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

/**
 * 获取用户基本信息
 * @returns
 */
async function getUserInfo(shopId) {
  let info = store.state.user.userInfo;
  if (isNotEmpty(info) && !shopId) {
    return info;
  } else {
    let userStr = null;
    if (shopId) {
      userStr = await router.app.$axios.get(
        api.user.info + "?shopId=" + shopId
      );
    } else {
      userStr = await router.app.$axios.get(api.user.info);
    }
    if (userStr) {
      store.commit("user/setUserInfo", userStr);
    }
    return userStr;
  }
}
/**
 * 店铺是否存在
 * @returns
 */
async function isExistShop(shopId) {
  const shopInfo = await router.app.$axios.post(
    api.info.getShopInfo + "?shopId=" + shopId
  );
  return shopInfo.result;
}

//屏蔽重复点击路由时的警告
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

router.beforeEach(async (to, from, next) => {
  // ————————————————start——————————————核心权限控制代码, 勿动———————————————————————————
  let allUrl = routes[0].children.map((urlEntry) => urlEntry.path);
  let errorUrl = ["/error/error404.html", "/error/error401.html"];
  allUrl.push(errorUrl);
  if (errorUrl.includes(to.path)) {
    store.state.user.userInfo = null;
  }
  const regex = /^\/\d{1,10}$/;

  if (!allUrl.includes(to.path) && !regex.test(to.path)) {
    window.location.href = store.state.error.error404;
    return;
  }
  let userInfo = await getUserInfo();
  if (
    regex.test(to.path) &&
    store.state.user.userInfo.userTypeId !== shopCenterConst.role.manager
  ) {
    let shopId = to.path.slice(1);
    const res = await isExistShop(shopId);
    if (res) {
      window.location.href = store.state.error.error401;
    } else {
      window.location.href = store.state.error.error404;
    }
    return;
  }

  if (
    regex.test(to.path) &&
    store.state.user.userInfo.userTypeId === shopCenterConst.role.manager
  ) {
    let shopId = to.path.slice(1);
    const res = await isExistShop(shopId);
    if (res && !sessionStorage.getItem("shopId")) {
      sessionStorage.setItem("shopId", shopId);
      userInfo = await getUserInfo(shopId);
    }
    // 👇 = router.beforeEach() to.path = "/"  & userInfo != null
    next("/");
  } else if (
    store.state.user.userInfo.userTypeId === shopCenterConst.role.manager &&
    sessionStorage.getItem("shopId") &&
    !regex.test(to.path)
  ) {
    let shopId = sessionStorage.getItem("shopId");
    const res = await isExistShop(shopId);
    if (res) {
      userInfo = await getUserInfo(shopId);
    }
  }

  let bossURL = ["/info/shop/employee-list"];
  let authURL = [
    "/resource/article/upload",
    "/resource/video/upload",
    "/resource/document/upload",
  ];
  if (isNotEmpty(userInfo) && userInfo.shopId > 0) {
    // 试营业和已下线=无权限
    if (
      to.meta.needLogin &&
      (isOpenPermissionDialog(userInfo) === 1 ||
        isOpenPermissionDialog(userInfo) === 2 ||
        isOpenPermissionDialog(userInfo) === 3) &&
      "/marketing/addActivity" === to.path
    ) {
      window.location.href = store.state.error.error401;
      return;
    } else if (
      (to.meta.needLogin &&
        userInfo.userTypeId === shopCenterConst.role.employee &&
        bossURL.includes(to.path)) ||
      (to.meta.needLogin &&
        (isOpenPermissionDialog(userInfo) === 1 ||
          isOpenPermissionDialog(userInfo) === 3) &&
        authURL.includes(to.path))
    ) {
      window.location.href = store.state.error.error401;
      return;
    }
  }
  // ————————————————end——————————————核心权限控制代码, 勿动———————————————————————————

  //无需验证，或者已经登录，放行
  if (!to.meta.needLogin || isNotEmpty(userInfo)) {
    if (userInfo.shopId > 0) {
      //高亮当前页面所对应菜单
      if (to.path == "/resource/video/upload") {
        // 视频上传对应视频管理菜单
        store.commit("setActiveIndex", "/resource/video/list");
      } else if (to.path == "/resource/document/upload") {
        // 资料上传对应资料管理菜单
        store.commit("setActiveIndex", "/resource/document/list");
      } else if (to.path == "/resource/album/upload") {
        // 专辑上传对应专辑管理菜单
        store.commit("setActiveIndex", "/resource/album/list");
      } else if (
        to.path == "/info/shop/m-index-decoration" ||
        to.path == "/info/shop/index-decoration"
      ) {
        // 首页PC装修和移动装修对应店铺装修菜单
        store.commit("setActiveIndex", "/info/shop/shop-decoration-index");
      } else if (to.path == "/resource/article/upload") {
        // 文章上传对应文章管理菜单
        store.commit("setActiveIndex", "/resource/article/list");
      } else if (to.path == "/marketing/addActivity") {
        // 新增活动对应限时折扣管理菜单
        store.commit("setActiveIndex", "/marketing/discount");
      } else if (to.path == "/authentication/enterprise-apply") {
        // 企业认证对应店铺认证菜单
        store.commit("setActiveIndex", "/authentication/shop-authentication");
      } else {
        store.commit("setActiveIndex", to.path);
      }
      next();
    } else {
      window.location.href = store.state.error.error401;
      return;
    }
    next();
  } else {
    next(store.state.system.logSSOUrl);
  }
  next();
});

export default router;
